fragment ContactForCoreEntityFragment on Contact {
    id
    name
    avatarUrl
    initials
    lastContactedTime
    htmlUrlPath
    description
    jobTitle
    primaryEmailAddress
    hasDuplicates
    phones {
        primary {
            value {
                id
                numberFormatted
                extension
                numberFormattedWithCountryCode
            }
        }
    }
}
